export default __webpack_public_path__ + "static/media/Logo-Black.53b0be96.png";